/**
 * Missing Model Throwable Error
 */
export class MissingModel extends Error {
  constructor ({ collection }, ...params) {
    super(...params)
    this.name = '[Collection::MissingModel]'
    this._collection = collection
  }

  toString () {
    return `'${this._collection}' collection doesn't has a model!`
  }
}

/**
 * Invalid model provided to add method of a collection Throwable Error
 */
export class InvalidModelProvided extends Error {
  constructor ({ collection, model }, ...params) {
    super(...params)
    this.name = '[Collection::InvalidModelProvided]'
    this._collection = collection
    this._model = model
  }

  toString () {
    return `Invalid model property provided to '${this._collection}' collection add (${this._model})!`
  }
}

/**
 * Wrong model instance provided to the collection Throwable Error
 */
export class WrongModel extends Error {
  constructor ({ collection, model }, ...params) {
    super(...params)
    this.name = '[Collection::WrongModel]'
    this._collection = collection
    this._model = model
  }

  toString () {
    return `Invalid model type [${this._model}] provided to '${this._collection}' collection!`
  }
}
